import React from 'react';
import { 
  Box, 
  Grid, 
  TextField, 
  Button, 
  styled, 
  FormControlLabel, 
  Checkbox, 
  FormHelperText, 
  FormGroup 
} from '@mui/material';
import BaseCodeSelectbox from '../common/form/selectbox/BaseCodeSelectbox';
import TextMaskBusinessNo from '../common/form/TextMaskBusinessNo';

const FormLabel = styled(Box)(({ theme }) => ({
  //backgroundColor:'#ddd',
  ...theme.typography.subtitle2,
  borderRight: `1px solid ${theme.palette.divider}`,
  textAlign: 'center',
}));

const PartnerForm = ({ formik, type }) => {
  // Handler for checkbox changes that updates the tradeTyp field
// PartnerForm 내부
const handleTradeTypChange = (event) => {
  const { value, checked } = event.target;               // value: '매출처' 등
  const current = Array.isArray(formik.values.tradeTyp)
    ? formik.values.tradeTyp
    : [];

  const next = checked
    ? [...current, value]                                  // 체크 추가
    : current.filter(v => v !== value);                   // 체크 해제하면 제거

  formik.setFieldValue('tradeTyp', next);
};
  
  // Check if a specific trade type is selected
  // const isTradeTypSelected = (type) => {
  //   return formik.values.tradeTyp && formik.values.tradeTyp.split(',').includes(type);
  // };
  const isTradeTypSelected = (type) => {
    const raw = formik.values.tradeTyp;
    // 1) 배열인 경우
    if (Array.isArray(raw)) {
      return raw.includes(type);
    }
    // 2) 혹시 문자열("매출처,제조사")로 남아있다면 split 후 trim
    if (typeof raw === 'string' && raw.length > 0) {
      return raw.split(',').map(s => s.trim()).includes(type);
    }
    // 3) 그 외(빈값 등)
    return false;
  };
  const isAdd = type === 'add';

  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          px: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>거래처 종류</FormLabel>
          </Grid>
          <Grid item xs={3}>
            <BaseCodeSelectbox
              formik={formik}
              variant="outlined"
              required={true}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'PARTNER',
                slcCd: 'PARTNER_TYP',
                useYn: 'Y',
              }}
              name="partnerTyp"
              size="small"
            />
          </Grid>
          <Grid item xs={3}>
            <FormLabel>산업체 유형</FormLabel>
          </Grid>
          <Grid item xs={3}>
            <BaseCodeSelectbox
              formik={formik}
              variant="outlined"
              required={true}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'INC_TYP',
                useYn: 'Y',
              }}
              name="incTyp"
              size="small"
            />
          </Grid>
        </Grid>

        {/* New tradeTyp Field with Checkboxes */}
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          {/* <Grid item xs={3}>
            <FormLabel>거래 유형</FormLabel>
          </Grid>
          <Grid item xs={3}>
          <FormGroup row>
  {['매출처','매입처','제조사'].map((label) => (
    <FormControlLabel
      key={label}
      control={
        <Checkbox
          size="small"
          value={label}                                    // 👉 name 대신 value 사용
          checked={formik.values.tradeTyp.includes(label)}// 배열.includes
          onChange={handleTradeTypChange}
        />
      }
      label={label}
    />
  ))}
</FormGroup>
{formik.touched.tradeTyp && formik.errors.tradeTyp && (
  <FormHelperText error>{formik.errors.tradeTyp}</FormHelperText>
)}
          </Grid> */}
          <Grid item xs={3}>
            <FormLabel>사업자번호</FormLabel>
          </Grid>
          <Grid item xs={3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="regNumber"
              name="regNumber"
              value={formik.values.regNumber}
              onChange={(event) => {
                // console.log(event.target.value);
                formik.setFieldValue('regNumber', event.target.value);
              }}
              error={
                formik.touched.regNumber && Boolean(formik.errors.regNumber)
              }
              helperText={formik.touched.regNumber && formik.errors.regNumber}
              InputProps={{
                inputComponent: TextMaskBusinessNo,
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>거래처명</FormLabel>
          </Grid>
          <Grid item xs={3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="partnerNm"
              name="partnerNm"
              value={formik.values.partnerNm}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerNm && Boolean(formik.errors.partnerNm)
              }
              helperText={formik.touched.partnerNm && formik.errors.partnerNm}
            />
          </Grid>
          <Grid item xs={3}>
            <FormLabel>여신한도</FormLabel>
          </Grid>
          <Grid item xs={3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="loanAmt"
              name="loanAmt"
              value={formik.values.loanAmt}
              onChange={formik.handleChange}
              error={
                formik.touched.loanAmt && Boolean(formik.errors.loanAmt)
              }
              helperText={formik.touched.loanAmt && formik.errors.loanAmt}
            />
          </Grid>
        </Grid>
        
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>연락처</FormLabel>
          </Grid>
          <Grid item xs={isAdd ? 9 : 3}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="partnerPhone"
              name="partnerPhone"
              value={formik.values.partnerPhone}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerPhone &&
                Boolean(formik.errors.partnerPhone)
              }
              helperText={
                formik.touched.partnerPhone && formik.errors.partnerPhone
              }
            />
          </Grid>

          {!isAdd && (
            <>
              <Grid item xs={3}>
                <FormLabel>거래처코드</FormLabel>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  disabled
                  id="partnerCd"
                  name="partnerCd"
                  value={formik.values.partnerCd}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.partnerCd &&
                    Boolean(formik.errors.partnerCd)
                  }
                  helperText={
                    formik.touched.partnerCd && formik.errors.partnerCd
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>주소</FormLabel>
          </Grid>
          <Grid item xs={9}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="partnerAddr"
              name="partnerAddr"
              value={formik.values.partnerAddr}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerAddr && Boolean(formik.errors.partnerAddr)
              }
              helperText={
                formik.touched.partnerAddr && formik.errors.partnerAddr
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={3}>
            <FormLabel>참고사항</FormLabel>
          </Grid>
          <Grid item xs={9}>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="partnerDesc"
              name="partnerDesc"
              multiline
              rows={5}
              value={formik.values.partnerDesc}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerDesc && Boolean(formik.errors.partnerDesc)
              }
              helperText={
                formik.touched.partnerDesc && formik.errors.partnerDesc
              }
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2,
          }}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default PartnerForm;
